import Vue from "vue";
import App from "./components/App";
import Helpers from "./mixins/Helpers";
import store from "./store";

import moment from "moment";
import VueMoment from "vue-moment";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

moment.locale("en-GB");

import VueGtm from "vue-gtm";
Vue.use(VueGtm, {
  id: "GTM-KDPGMZR", // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true // Whether or not display console logs debugs (optional)
});

require("chart.js");

var en = require("@/locales/en.json");

const messages = {
  en: en,
  pt: $.extend({}, en, require("@/locales/pt.json"))
};

const i18n = new VueI18n({
  locale: "en",
  messages,
  silentTranslationWarn: true
});

Vue.use(VueMoment, {
  moment
});

Vue.config.productionTip = false;
Vue.mixin(Helpers);

new Vue({
  el: "#app",
  store,
  i18n,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js